<form [formGroup]="formGroup">
    <div class="select" [ngClass]="{ 'is-fullwidth' : fullwidth }">
        <select [ngClass]="'has-text-' + alignment" formControlName="control">
            <option *ngFor="let control of controls ; let i = index" [ngValue]="i">
                {{ control.name?? control.value }}
            </option>
        </select>
    </div>
</form>